import { useMemo } from "react";
import { Autocomplete } from "@aclymatepackages/atoms";
import productMaterials from "@aclymatepackages/lists/productMaterials";

const ProductMaterials = ({
  multiple = false,
  setValue,
  value,
  label = "Select a product material",
  ...otherProps
}) => {
  // Build options with guaranteed id and name, and sort by name
  const options = useMemo(() => {
    return (productMaterials || [])
      .map((material) => ({
        id: material.id ?? material.value ?? String(material.label ?? material),
        name:
          material.label ?? String(material.id ?? material.value ?? material),
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, []);

  const renderOption = (props, option) => {
    return (
      <li {...props} key={option.id}>
        {option?.name}
      </li>
    );
  };

  // Map incoming value (id or array of ids) to option object(s) expected by Autocomplete
  const selectedValue = multiple
    ? Array.isArray(value)
      ? options.filter((o) => value.includes(o.id))
      : []
    : options.find((o) => o.id === value) || null;

  const handleChange = (event, newValue) => {
    if (multiple) {
      const ids = Array.isArray(newValue) ? newValue.map((v) => v.id) : [];
      return setValue(ids);
    }

    return setValue(newValue ? newValue.id : null);
  };

  return (
    <Autocomplete
      label={label}
      availableOptions={options}
      multiple={multiple}
      renderOption={renderOption}
      value={selectedValue}
      onChange={handleChange}
      {...otherProps}
    />
  );
};

export default ProductMaterials;
